import * as React from 'react';
import * as main from "../../styles/main.module.scss";
import * as forWhom from "./style.module.scss";

export const ForWhom = () => {
  return (
    <section className={forWhom.forWhom}>
      <div className="container">
        <div className={forWhom.forWhom__wrapper}>
          <div className={forWhom.forWhom__content}>
            <h2 className={`${main.title_h2} ${forWhom.forWhom__title}`}>Если ваш ребёнок</h2>
            <ul className={forWhom.forWhom__list}>
              <li className={forWhom.forWhom__item}>читает медленно и/или по слогам,</li>
              <li className={forWhom.forWhom__item}>плохо понимает прочитанное,</li>
              <li className={forWhom.forWhom__item}>не может сконцентрироваться во время чтения,</li>
            </ul>
          </div>
          <div className={forWhom.forWhom__textBlock}>
            <p>благодаря курсу за 1–3 месяца <strong>он сможет преодолеть эти сложности</strong> (срок зависит от
              интенсивности занятий).</p>
          </div>
        </div>
        <div className={forWhom.forWhom__undertext}>
          <p>Эффективное чтение помогает ребёнку легче и успешнее учиться по большинству предметов:</p>
          <ul>
            <li className={forWhom.forWhom__undertextItem}>понимать текстовые задачи и запоминать правила;</li>
            <li className={forWhom.forWhom__undertextItem}>быстрее и качественнее осваивать параграфы;</li>
            <li className={forWhom.forWhom__undertextItem}>улавливать ключевые мысли и легко отвечать на вопросы по тексту.
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};
